/* ============================================================
   WELL WORN LONDON - LA POLICE DU SITE DANS LE COMPOSANT SHOP PAY
   2026-09-08.

   Le texte du paiement en trois fois vit dans un shadow DOM
   ouvert, et le composant y fixe lui-meme sa police (GTStandard,
   la police de Shopify). font-family ne traverse pas cette
   barriere : contrairement a la taille, a la couleur et a la
   graisse, elle ne s'herite pas. On injecte donc une regle dans
   le shadow root pour retomber sur Jost, la police du site.

   Seule la police change. Le texte, le logo Shop et le lien
   d'information ne sont pas touches, comme l'exige l'affichage
   des offres de paiement fractionne.

   Le composant se rend de facon asynchrone et se re-rend a
   chaque changement de variante : on repasse donc pendant
   quelques secondes, puis on surveille chaque shadow root.
   ============================================================ */

(function () {
  var CSS = '#shopify-installments,#shopify-installments *{font-family:Jost,sans-serif!important}';

  function habille(el) {
    var racine = el.shadowRoot;
    if (!racine) return;
    if (!racine.getElementById('ml-shop-pay-font')) {
      var style = document.createElement('style');
      style.id = 'ml-shop-pay-font';
      style.textContent = CSS;
      racine.appendChild(style);
    }
    if (!el.dataset.mlObserve) {
      el.dataset.mlObserve = '1';
      new MutationObserver(function () {
        if (!racine.getElementById('ml-shop-pay-font')) {
          var s = document.createElement('style');
          s.id = 'ml-shop-pay-font';
          s.textContent = CSS;
          racine.appendChild(s);
        }
      }).observe(racine, { childList: true });
    }
  }

  function passe() {
    var liste = document.querySelectorAll('shopify-payment-terms');
    for (var i = 0; i < liste.length; i++) habille(liste[i]);
  }

  passe();
  document.addEventListener('DOMContentLoaded', passe);

  var n = 0;
  var minuteur = setInterval(function () {
    passe();
    if (++n > 24) clearInterval(minuteur);
  }, 250);
})();
